import Constants from '@/Constants';
import { FileUploadData } from '@/hooks/upload/FileUpload';
import { getAuth } from '@/services/IdentityService';
import { getHost } from '@/services/UtilService';
import { ApplicationState } from '@/store';
import { massImportEnrollmentRequest } from '@/store/programClass/actions';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ActionButtonWithDropdownItems from '../ActionButtonWithDropdownItems';
import GroupActionModal from '../GroupActionModal';
import Upload, { UploadType } from '../Upload';
import './style.scss';

interface Props {
    applicationId: number;
    programClassId: number;
    organizationId: number;
    totalEnrollmentsCount: number;
    setShowFindPersonModal: CallableFunction;
    setShowOnlyEnrolledInModal: CallableFunction;
    disable?: boolean;
}

const getTemplateURI = () => {
    const token = (getAuth() || '').replace('bearer ', '');
    return `${getHost()}${Constants.LMS_PROGRAM_CLASS_TEMPLATE_URI.replace('%t', token)}`;
};

const ClassFormEnrollmentSection: React.FC<Props> = ({
    applicationId,
    programClassId,
    organizationId,
    totalEnrollmentsCount,
    setShowFindPersonModal,
    setShowOnlyEnrolledInModal,
    disable = false,
}: Props) => {
    const dispatch = useDispatch();
    const { strings } = useSelector((state: ApplicationState) => ({ strings: state.locale.data }));
    const [visible, setVisible] = useState<boolean>(false);

    const handleCompleteUpload = (fileUploadData: FileUploadData) => {
        dispatch(
            massImportEnrollmentRequest({
                filename: fileUploadData.key.replace('enrollment-processes/', ''),
                programClassId,
                applicationId,
                organizationId,
                multipleClassEnrollmentMode: true,
            }),
        );
    };

    return (
        <>
            <section className="class-form-enrollment-section">
                <p>{strings.ENROLLMENT}</p>
                <div className="enroll-section">
                    <div>
                        <i className="material-icons-outlined align-middle">{Constants.icons.PERSON}</i>
                        <span className="m-left--xs align-middle">
                            <span className="font-weight-bold">{totalEnrollmentsCount} </span>
                            {totalEnrollmentsCount > 1 ? strings.ENROLLED_STUDENTS : strings.ENROLLED_STUDENT}
                        </span>
                    </div>

                    <div className="show-all-section">
                        {totalEnrollmentsCount > 0 && (
                            <button
                                className="btn btn-link"
                                disabled={disable}
                                onClick={() => {
                                    setShowOnlyEnrolledInModal(true);
                                    setShowFindPersonModal(true);
                                }}
                            >
                                <span className="edit-btn btn">{strings.SHOW_ALL}</span>
                            </button>
                        )}
                    </div>
                </div>
                <GroupActionModal modalVisible={visible} onHide={() => setVisible(false)} programClassId={programClassId} />
                <div>
                    <ActionButtonWithDropdownItems
                        actionButtonClick={() => {
                            setShowOnlyEnrolledInModal(false);
                            setShowFindPersonModal(true);
                        }}
                        actionButtonLabel={strings.ENROLL_STUDENTS}
                        disabled={disable}
                        dropdownLabel={strings.MASS_ENROLL_STUDENTS}
                    >
                        <Upload
                            customFolder="enrollment-processes/"
                            disabled={disable}
                            onComplete={handleCompleteUpload}
                            typeAccepted="SPREADSHEET"
                            uploadType={UploadType.MASS_IMPORT}
                        />
                        <a className="dropdown-item pt-3 pb-3" href={getTemplateURI()} rel="noreferrer" target="_blank">
                            <i className="material-icons-outlined va-t mr-1">save_alt</i>
                            {strings.massImport.TEMPLATE}
                        </a>
                    </ActionButtonWithDropdownItems>
                    <button
                        className="btn btn-primary btn-sm font-weight-bold colored pl-3 pr-3 outline-drop"
                        disabled={disable}
                        onClick={() => setVisible(true)}
                    >
                        {strings.AUTOMATIC_ENROLL}
                    </button>
                </div>
            </section>
        </>
    );
};

export default ClassFormEnrollmentSection;
